export default theme => ({
  select__threat: {
    boxShadow: theme.forms.select.boxShadow,
    width: '360px',
  },
  span__noData: {
    paddingTop: 8,
  },
});
